var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',[_vm._v("\n  "+_vm._s(_vm.$t('Min Stock'))+"\n")]):_c('td',[_c('input',{staticClass:"form-control form-control-sm min-stock-input",attrs:{"type":"number","min":"0","placeholder":_vm.$t('Not set')},domProps:{"value":_vm.rowData.min_stock},on:{"blur":function($event){_vm.updateMinStock($event)},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }$event.target.blur()}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6e47ff2","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VueTableStockMinLevel.vue
// module id = 1314
// module chunks = 86